import React from 'react';
import classes from './AppointmentStatusContextMenuTemplate.module.css';

const AppointmentStatusContextMenuTemplate = (itemData) => {
    return (
        <div style={{ padding: '0 3px' }}>
            <i className={`${itemData.icon} ${classes.tooltipIcons}`} />{itemData.status}
        </div>
    );
};
export default AppointmentStatusContextMenuTemplate;
